(() => {
  const rootEls = document.querySelectorAll('[data-ppc]');
  if (!rootEls.length) return;

  const pad2 = (n) => String(n).padStart(2, '0');

  const parseEndAt = (str) => {
    // Expects "YYYY-MM-DD HH:MM"
    if (!str || typeof str !== 'string') return null;
    const m = str.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!m) return null;
    const [_, Y, Mo, D, H, Mi] = m;
    // Store timezone local parse
    return new Date(Number(Y), Number(Mo) - 1, Number(D), Number(H), Number(Mi), 0, 0);
  };

  const open = (el) => {
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    const closeBtn = el.querySelector('[data-ppc-close]');
    closeBtn && closeBtn.focus();
    document.documentElement.classList.add('ppc-lock');
    document.body.style.overflow = 'hidden';
  };

  const close = (el) => {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ppc-lock');
    document.body.style.overflow = '';
  };

  rootEls.forEach((wrap) => {
    const cfgEl = wrap.querySelector('[data-ppc-config]');
    const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    const id = cfg.id || wrap.id || 'promo-popup';

    // Close handlers
    wrap.addEventListener('click', (e) => {
      if (e.target.matches('[data-ppc-close]')) close(wrap);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) close(wrap);
    });

    // Copy coupon
    const copyBtn = wrap.querySelector('[data-ppc-copy]');
    const codeEl = wrap.querySelector('[data-ppc-code]');
    const statusEl = wrap.querySelector('[data-ppc-status]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', async () => {
        const code = (codeEl.textContent || '').trim();
        try {
          await navigator.clipboard.writeText(code);
          if (statusEl) statusEl.textContent = 'Gekopieerd ✅';
        } catch {
          if (statusEl) statusEl.textContent = 'Kopiëren mislukt — kopieer handmatig.';
        }
      });
    }

    // Countdown
    const endAt = parseEndAt(cfg.endAt);
    const dEl = wrap.querySelector('[data-ppc-days]');
    const hEl = wrap.querySelector('[data-ppc-hours]');
    const mEl = wrap.querySelector('[data-ppc-mins]');
    const sEl = wrap.querySelector('[data-ppc-secs]');

    const tick = () => {
      if (!endAt) return;
      const diff = endAt.getTime() - Date.now();
      const t = Math.max(0, diff);

      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      const mins = Math.floor((t / (1000 * 60)) % 60);
      const secs = Math.floor((t / 1000) % 60);

      if (dEl) dEl.textContent = pad2(days);
      if (hEl) hEl.textContent = pad2(hours);
      if (mEl) mEl.textContent = pad2(mins);
      if (sEl) sEl.textContent = pad2(secs);
    };

    tick();
    if (endAt) setInterval(tick, 1000);

    // Auto-open
    const oncePerSession = cfg.oncePerSession !== false; // default true
    const sessionKey = `ppc_seen_${id}`;

    const shouldOpen = () => {
    // If already subscribed, never open again
    try {
        if (localStorage.getItem('ppc_newsletter_subscribed') === '1') return false;
    } catch(e) {}

    if (!oncePerSession) return true;
    return sessionStorage.getItem(sessionKey) !== '1';
    };


    const markOpened = () => {
      if (oncePerSession) sessionStorage.setItem(sessionKey, '1');
    };

    const run = () => {
      if (!shouldOpen()) return;
      open(wrap);
      markOpened();
    };

    const delay = Number(cfg.delay || 0);
    if (delay > 0) setTimeout(run, delay * 1000);
    else run();
  });
})();
